import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PlansService } from './plans.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PublicLibraryResolverService implements Resolve<any>{
  userData;
  constructor(
    private planService: PlansService,
    private authService: AuthService
  ) {
    // this.userData = this.authService.getCurrentUser();
  }

  getData(){
    return this.authService.getCurrentUser();
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<any> {
    this.userData = this.getData();
    if (this.userData.user.subscription.plan.additional_libraries_allowed || (this.userData.user.last_plan && this.userData.user.last_plan.plan.additional_libraries_allowed)) {
      return this.planService.getCurrentAddOns("additional_public_library")
        .pipe(map(response => {
          if (response.data.purchased_add_ons.length) {
            return response.data.purchased_add_ons;
          } else {
            return null;
          }
        }), catchError((err: any) => {
          // TODO: reroute here
          return of(null);
        }));
    } else {
      return of(null);
    }

  }
}
